module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAG0lEQVQImWM4cPrOfxCQEFH9z8SABBAcBgYGACGrCLdkEqpsAAAAAElFTkSuQmCC"